import { JSX, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { message } from "antd";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import { CardContainer } from "../../components/Card/CardContainer";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import StepAntd from "../../components/StepAntd/StepAntd";
import { generateShopTierMockData } from "../ShopTier/mockData";
import { resolveShopTierConfig } from "../ShopTier/config";
import { useLocalStorage } from "../../hook/useLocalStorage";
import Step2, { Step2Result } from "./CreateShopTierBenefitStep/Step2";
import Step3 from "./CreateShopTierBenefitStep/Step3";

function EditShopTierBenefit(): JSX.Element {
  const navigate = useNavigate();
  const { year } = useParams<{ year: string }>();
  const [company] = useLocalStorage("profile", null);
  const config = resolveShopTierConfig(company?.company);
  const mockData = generateShopTierMockData(config);
  const configYear = mockData.configYears.find((y) => y.year === year);
  const originalTiers = configYear?.tiers || [];

  const [step, setStep] = useState<number>(0);
  const [editResult, setEditResult] = useState<Step2Result | null>(null);
  const stepItems = [
    { title: "แก้ไขสิทธิประโยชน์" },
    { title: "ตรวจสอบ" },
  ];

  const goNext = () => setStep((s) => Math.min(s + 1, stepItems.length - 1));
  const goBack = () => setStep((s) => Math.max(s - 1, 0));

  const stepsComponents = [
    <Step2
      key={0}
      mode="edit"
      config={config}
      sourceTiers={originalTiers}
      onBack={() => navigate(-1)}
      onNext={(result) => {
        setEditResult(result);
        goNext();
      }}
    />,
    <Step3
      key={1}
      mode="edit"
      config={config}
      year={year || ""}
      data={editResult}
      sourceTiers={originalTiers}
      onBack={goBack}
      onConfirm={() => message.info("ฟังก์ชันนี้อยู่ระหว่างการพัฒนา")}
    />,
  ];

  return (
    <CardContainer>
      <PageTitleNested
        title={`แก้ไขสิทธิประโยชน์${year}`}
        showBack
        onBack={() => (step === 0 ? navigate(-1) : goBack())}
        customBreadCrumb={
          <BreadCrumb
            data={[
              { text: "ตั้งค่าระดับ", path: -1 },
              { text: `แก้ไขสิทธิประโยชน์${year}`, path: window.location.pathname },
            ]}
          />
        }
        extra={<StepAntd current={step} items={stepItems} />}
      />
      {stepsComponents[step]}
    </CardContainer>
  );
}

export default EditShopTierBenefit;
